import { useDispatch } from "react-redux";

import { combineReducers, configureStore } from "@reduxjs/toolkit";

import assessmentsVitals from "./slices/assessments-vitals";
import birth from "./slices/birth";
import bloodType from "./slices/blood-type";
import checklistTemplates from "./slices/checklist-templates";
import checklists from "./slices/checklists";
import clientAllergies from "./slices/client-allergies";
import clientBilling from "./slices/client-billing";
import clientFlags from "./slices/client-flags";
import clientHistory from "./slices/client-history";
import clientMedications from "./slices/client-medication";
import clientProblems from "./slices/client-problems";
import clientProfile from "./slices/client-profile";
import clients from "./slices/clients";
import dotPhrases from "./slices/dot-phrases";
import eduFolders from "./slices/edu-folders";
import eduResources from "./slices/edu-resources";
import episodeOfCare from "./slices/episode-of-care";
import formsLibrary from "./slices/forms-library";
import gtpal from "./slices/gtpal";
import gynecologicalEncounter from "./slices/gynecological-encounter";
import inbox from "./slices/inbox";
import inLabor from "./slices/inLabor";
import labOrderTemplates from "./slices/lab-order-templates";
import labOrders from "./slices/lab-orders";
import laborAutomaticTimers from "./slices/labor-automatic-timers";
import laborStages from "./slices/labor-stages";
import newbornIPP from "./slices/newborn-ipp";
import newbornPostpartum from "./slices/newborn-postpartum";
import postpartumEncounter from "./slices/postpartum-encounter";
import postpartumObservations from "./slices/postpartum-observations";
import pregnancy from "./slices/pregnancy";
import procedures from "./slices/procedures";
import resourcePolling from "./slices/resource-polling";
import transferOfCare from "./slices/transfer-of-care";
import uploadedFiles from "./slices/uploaded-files";

export const rootReducer = combineReducers({
  assessmentsVitals,
  birth,
  bloodType,
  clientAllergies,
  clientBilling,
  clientFlags,
  clientHistory,
  clientMedications,
  clientProblems,
  clientProfile,
  clients,
  dotPhrases,
  pregnancy,
  eduResources,
  episodeOfCare,
  formsLibrary,
  gtpal,
  gynecologicalEncounter,
  inLabor,
  inbox,
  laborAutomaticTimers,
  labOrderTemplates,
  labOrders,
  laborStages,
  newbornIPP,
  newbornPostpartum,
  postpartumEncounter,
  postpartumObservations,
  procedures,
  resourcePolling,
  transferOfCare,
  uploadedFiles,
  checklistTemplates,
  checklists,
  eduFolders,
});

const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch<AppDispatch>;

export default store;
